import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { BunkeringStatusEnum } from 'src/types/ViewModel/Bunkering/BunkeringEvent';
import { StatusIcon } from 'src/components/ui/status-icon/NoonReportStatusIcon.styles';
import { BunkeringStatus } from 'src/types/ViewModel/Bunkering/BunkeringStatus';

export const BunkerRegistrationStatusIcon = (registrationStatus: BunkeringStatusEnum, allStatuses: BunkeringStatus[] = []) => {
    switch (registrationStatus) {
        case BunkeringStatusEnum.Unknown:
            return (
                <StatusIcon className="status-icon status-missing">
                    <FontAwesomeIcon icon="exclamation-circle" title="New bunkering" />
                </StatusIcon>
            );
        case BunkeringStatusEnum.Registered:
            return (
                <StatusIcon className="status-icon status-incomplete">
                    <FontAwesomeIcon icon="exclamation-circle" title="Awaiting approval for use" />
                </StatusIcon>
            );
        case BunkeringStatusEnum.Approved:
            return (
                <StatusIcon className="status-icon status-approved">
                    <FontAwesomeIcon icon="check-circle" title="Approved for use" />
                </StatusIcon>
            );
        case BunkeringStatusEnum.InUse:
            if (!allStatuses.some((status) => status.status === BunkeringStatusEnum.Approved)) {
                return (
                    <StatusIcon className="status-icon status-incomplete">
                        <FontAwesomeIcon icon="check-circle" title="Approval bypassed" />
                    </StatusIcon>
                );
            }
            return (
                <StatusIcon className="status-icon status-approved">
                    <FontAwesomeIcon icon="check-circle" title="In use" />
                </StatusIcon>
            );
        case BunkeringStatusEnum.Rejected:
            return (
                <StatusIcon className="status-icon status-missing">
                    <FontAwesomeIcon icon="check-circle" title="Rejected" />
                </StatusIcon>
            );
        case BunkeringStatusEnum.Debunkered:
            return (
                <StatusIcon className="status-icon status-saved">
                    <FontAwesomeIcon icon="exclamation-circle" title="Debunkered" />
                </StatusIcon>
            );
        case BunkeringStatusEnum.Spent:
            if (
                allStatuses.some((status) => status.status === BunkeringStatusEnum.InUse) &&
                !allStatuses.some((status) => status.status === BunkeringStatusEnum.Approved)
            ) {
                return (
                    <StatusIcon className="status-icon status-incomplete">
                        <FontAwesomeIcon icon="check-circle" title="Spent, but never approved" />
                    </StatusIcon>
                );
            }
            return (
                <StatusIcon className="status-icon status-saved">
                    <FontAwesomeIcon icon="check-circle" title="Spent" />
                </StatusIcon>
            );
    }
};
